import { createApp } from "vue"
import { createHead } from "@unhead/vue"
import { registerScrollSpy } from "vue3-scroll-spy"
import App from "@/App.vue"
import VueCookieAcceptDecline from "vue-cookie-accept-decline"
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css"
import FlagIcon from "vue-flag-icon"
import VueSafeHTML, { allowedTags } from "vue-safe-html"

import Notifications from "notiwind"
import VueGoogleMaps from "vue-google-maps-community-fork"
import VuePlyr from "@skjnldsv/vue-plyr"
import InstantSearch from "vue-instantsearch/vue3/es"
import "@skjnldsv/vue-plyr/dist/vue-plyr.css"
import axios from "axios"
import { fr } from "yup-locales"
import { setLocale } from "yup"
import i18n from "./i18n"
import router from "@/router"
import store from "@/store"
import { QuillEditor } from "@vueup/vue-quill"
import "@vueup/vue-quill/dist/vue-quill.snow.css"
import AOS from "aos"
import VueExpandableImage from "@common/utils/expandable-image"
import VueConfetti from "vue-confetti"
import "aos/dist/aos.css"
import "@projetsolaire/ui/style.css"
import "@assets/css/style.css"
import { initializeGtm, initializeSentry } from "@plugins"
import { setApiBaseUrl } from "@projetsolaire/ui"
window.axios = axios

axios.defaults.baseURL = import.meta.env.VITE_ROOT_API
setApiBaseUrl(import.meta.env.VITE_ROOT_API)
setLocale(fr)

const auth =
  localStorage.getItem("auth") && JSON.parse(localStorage.getItem("auth"))

if (auth && auth.token && auth.expiresAt > Date.now()) {
  window.axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`
  store.commit("auth/login", auth)
} else if (auth) {
  localStorage.removeItem("auth")
}

const app = createApp(App)

//Disable Vue DevTools in prod
if (import.meta.env.MODE === "production") {
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.off()
  }
}

const head = createHead()

// Initialize plugins
initializeGtm(app, router)
initializeSentry(app, router)

registerScrollSpy(app)
app.component("QuillEditor", QuillEditor)
app.component("VueCookieAcceptDecline", VueCookieAcceptDecline)
app.use(head)
app.use(i18n)
app.use(router)
app.use(store)
app.use(InstantSearch)
app.use(Notifications)
app.use(VueSafeHTML, {
  allowedTags: [
    ...allowedTags,
    "span",
    "blockquote",
    "div",
    "p",
    "ul",
    "li",
    "a",
  ],
  allowedAttributes: ["title", "class", "href", "style"],
})
app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GMAPS_KEY,
    libraries: "places",
  },
})
app.use(VuePlyr)
app.use(FlagIcon)
  // Initialize AOS (not a Vue plugin, just call init)
  AOS.init({
    once: true,
    disable: "phone",
    duration: 700,
    easing: "ease-out-cubic",
  })
app.use(VueExpandableImage)
app.use(VueConfetti)
app.mount("#app")
